export function stringToColor(str) {
  // Return specific colors for certain strings
  if (str === "Reddit") return "#FF5700";
  if (str === "Ads") return "#FFCC17";
  if (str === "LP") return "#003366";
  if (str === "YouTube") return "#CD201F";
  if (str === "Kickstarter") return "#05CE78";
  if (str === "Instagram") return "#E1306C";
  if (str === "Newsletter") return "#004D99";
  if (str === "Whatsapp") return "#25D366";
  if (str === "LinkedIn") return "#0a66c2";
  if (str === "Discord") return "#5865F2";
  if (str === "TikTok") return "#FE2C55";
  if (str === "Review") return "#79f809ff"; // Bright red
  if (str === "Leads") return "#ff0000ff"; // Bright red
  if (str === "The Magic Cafe") return "#ff00ffff"; // Bright cyan
  // New hot-tone colors for additional strings
  if (str === "Kickstarter visitors not from ads") return "#eeee0cff"; // Bright orange-red
  if (str === "Landing Page Visitors") return "#50ce07ff"; // Hot pink-red
  if (str === "Landing Page visitors not from ads") return "#00d8feff"; // Bright red
  if (str === "Kickstarter Visitors") return "#f75200ff"; // Tomato red
  if (str === "BGG") return "#f44336"; // Light coral red
  if (str === "KS Total") return "rgba(56, 53, 92, 0.4)"; // Hot pink
  if (str === "Leidsch Dagblad") return "#ce7e00"; // Golden yellow
  if (str === "United Cardists") return "#E17055"; // Burnt orange

  if (str === "default") return "#000000"; // Default color for unknown types

  // Fallback to the original color generation for other strings
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = hash % 60; // 0-59
  const saturation = 85; // độ bão hòa cao, màu rực rỡ
  const lightness = 55; // sáng vừa phải, hơi đậm màu
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
